import { useEffect, useState } from "react";
import { adminApi } from "../api";

/**
 * Resolves the human label of an FK value, and offers a debounced typeahead
 * search against `/_lookup/{column}`. Returns label, list of options, loading flag.
 */
export default function useFkLookup({ schema, name, column, value, open, q }) {
  const [label, setLabel] = useState("");
  const [opts, setOpts] = useState([]);
  const [loading, setLoading] = useState(false);

  // Resolve label of current value
  useEffect(() => {
    let cancelled = false;
    if (value === null || value === undefined || value === "") { setLabel(""); return undefined; }
    adminApi.tableLookup(schema, name, column, { ids: String(value), limit: 1 })
      .then((r) => { if (!cancelled) setLabel((r.options && r.options[0] && r.options[0].label) || ""); })
      .catch(() => { if (!cancelled) setLabel(""); });
    return () => { cancelled = true; };
  }, [schema, name, column, value]);

  // Debounced fetch of options
  useEffect(() => {
    if (!open) return undefined;
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const r = await adminApi.tableLookup(schema, name, column, { q, limit: 25 });
        setOpts(r.options || []);
      } catch (e) {
        if (process.env.NODE_ENV !== "production") console.warn("useFkLookup search failed", e);
        setOpts([]);
      } finally {
        setLoading(false);
      }
    }, 200);
    return () => clearTimeout(t);
  }, [open, q, schema, name, column]);

  return { label, opts, loading };
}
